import React from 'react'
import { connect } from 'react-redux';

import ActionButtons from '../../commons/ActionButtons'
import TypeSection from './TypeSection'

import {
  buildAsset,
  updateAssetsStart,
} from '../../../actions';

import {
  getCashAssetIds,
  getDepositAssetIds,
} from './../../../reducers';

class Assets extends React.Component {

  onContinueClick = () => {
    this.props.updateAssetsStart()
  }

  onNewAssetClick = (payload) => {
    this.props.buildAsset(payload)
  }

  render() {
    const {
      cashIds,
      depositIds,
    } = this.props;

    return(
      <div>
        <h3>Existing assets</h3>
        <TypeSection
          assetType='cash'
          assetIds={ cashIds }
          onNewAssetClick={ this.onNewAssetClick }
        />

        <TypeSection
          assetType='deposit'
          assetIds={ depositIds }
          onNewAssetClick={ this.onNewAssetClick }
        />

        <ActionButtons
          continueEnabled={ true }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  cashIds: getCashAssetIds(state),
  depositIds: getDepositAssetIds(state),
})

export default connect(mapStateToProps, {
  buildAsset,
  updateAssetsStart,
})(Assets)
